import React from 'react';
import { motion } from 'framer-motion';

/**
 * ScrollReveal – A wrapper component that animates its children 
 * as they enter the viewport.
 */
const ScrollReveal = ({ children, direction = 'up', delay = 0, distance = 30 }) => {
    const directions = {
        up: { y: distance },
        down: { y: -distance },
        left: { x: distance },
        right: { x: -distance }
    };

    return (
        <motion.div
            initial={{ 
                opacity: 0, 
                ...directions[direction] 
            }}
            whileInView={{ 
                opacity: 1, 
                x: 0, 
                y: 0 
            }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ 
                duration: 0.8, 
                delay: delay, 
                ease: [0.16, 1, 0.3, 1] 
            }}
        >
            {children}
        </motion.div>
    );
};

export default ScrollReveal;
